import './styles.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'primereact/dropdown'

const CustomDropdown = (props) => {
  const { value, onChange, onBlur, options, optionLabel, className, placeholder, panelClassName, filter, disabled, showFlags = false, emptyFilterMessage, emptyMessage, error = false, loading = false, dropdownErrorMessage, appendTo = 'self', testId, isThemeApplied = true, customThemeDropdown, customThemePanel, filterItems } = props

  const { t } = useTranslation()

  const renderItemTemplate = (options) => {
    const isFirst = options?.id === 0

    return (
      <div className="dropdown-template-item">
        {showFlags && <img src={options?.flagURL || options?.flagsUrl} alt={optionLabel} className={`dropdown-template-icon ${isFirst ? 'first-item' : ''}`} />}
        {<span className="dropdown-template-label">{options?.languageName || options?.nicename || options?.countryName || options?.report || options?.year || options?.month || options?.label || options?.contractType || options?.contractName || options?.searchTag || options?.country_name || options?.state || options?.region}</span>}
      </div>
    )
  }

  const renderValueTemplate = (value) => {
    const isFirst = value?.id === 0

    if (!value) {
      return <span>{placeholder}</span>
    }

    return (
      <div className="dropdown-template-value">
        {showFlags && <img src={value?.flagURL || value?.flagsUrl} alt={'value?.countryName'} className={`dropdown-value-icon ${isFirst ? 'first-item' : ''}`} />}
        {<span className="dropdown-value-label">{value?.languageName || value?.nicename || value?.countryName || value?.report || value?.year || value?.month || value?.label || value?.contractType || value?.contractName || value?.searchTag || value?.country_name || value?.state || value?.region}</span>}
      </div>
    )
  }

  return (
    <div className="custom-dropdown-container">
      <Dropdown value={value} onChange={onChange} onBlur={onBlur} options={options || []} optionLabel={optionLabel} itemTemplate={renderItemTemplate} valueTemplate={renderValueTemplate} className={isThemeApplied ? `custom-dropdown ${className}` : customThemeDropdown} placeholder={placeholder || t('SELECT_COUNTRY')} panelClassName={isThemeApplied ? `custom-panel-style ${panelClassName}` : customThemePanel} filter={filter} disabled={disabled} emptyMessage={emptyMessage || t('NO_DATA_FOUND')} emptyFilterMessage={emptyFilterMessage || t('NO_DATA_FOUND')} resetFilterOnHide={true} loading={loading} dropdownErrorMessage={dropdownErrorMessage} appendTo={appendTo} data-testid={testId} filterBy={filterItems || optionLabel} />
      {error && <div className="dropdown-error-message">{dropdownErrorMessage}</div>}
    </div>
  )
}

export default CustomDropdown
